import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { BehaviorSubject } from 'rxjs';
import { LayoutUtilsService } from '../../../../../core/_base/crud';
import { InterventionHistoryListComponent } from '../intervention-history-list/intervetion-history-list.component';
import { PendProblemComponent } from '../pend-problem/pend-problem.component';
import { ManageProblemComponent } from '../manage-problem/manage-problem.component';

@Component({
  selector: 'kt-drp-dashboard-card',
  templateUrl: './drp-dashboard-card.component.html',
  styleUrls: ['./drp-dashboard-card.component.scss'],
})
export class DrpDashboardCardComponent implements OnInit {
  @Input() data;
  @Input() statusKey;
  @Input() isPv = false;
  @Input() verifyMedication;
  @Input() markErrorFn;
  @Input() patient;
  @Input() medications;
  @Output() refresh = new EventEmitter<any>();
  card;
  medicationError = false;
  isMouseHoverRx = new BehaviorSubject(false);

  constructor(
    private dialog: MatDialog,
    public layoutUtilsService: LayoutUtilsService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    if (this.isPv && !this.medicationError) {
      if (
        this.card &&
        this.card.is_verify === '0' &&
        this.card.medication_errors &&
        this.card.medication_errors.length > 0
      ) {
        this.medicationError = true;
      } else {
        this.card.medication_errors = [];
      }
    }
  }

  getCardClass(statusKey: string) {
    switch (statusKey.toUpperCase()) {
      case 'AD':
        return 'bg-blue';
      case 'EF':
        return 'bg-green';
      case 'IN':
        return 'bg-orange';
      case 'SA':
        return 'bg-velvet';
    }
  }

  mouseOut() {
    this.isMouseHoverRx.next(false);
    this.cdr.detectChanges();
  }

  mouseEnter() {
    this.isMouseHoverRx.next(true);
  }
  formatDate(date) {
    if (moment.isDate(new Date(date))) {
      return moment(date).format('MM-DD-YYYY');
    }
  }
  recurrentProblem(drp) {
    this.dialog.open(InterventionHistoryListComponent, {
      data: {
        patient: this.patient,
        drp,
      },
      width: '75vw',
      maxWidth: '75vw',
      height: '75vh',
    });
  }

  pendProblem(drp) {
    const dialogRef = this.dialog.open(PendProblemComponent, {
      data: {
        patient: this.patient,
        drp,
        from: 'later_date',
      },
      width: '75vw',
      maxWidth: '75vw',
      height: '85vh',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.refresh) {
        this.refresh.emit(result.refresh);
      }
    });
  }
  ignore(drp) {
    const dialogRef = this.dialog.open(PendProblemComponent, {
      data: {
        patient: this.patient,
        drp,
        from: 'ignore',
      },
      width: '65vw',
      maxWidth: '75vw',
      height: '65vh',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.refresh) {
        this.refresh.emit(result.refresh);
      }
    });
  }
  manageProblem() {
    const dialogRef = this.dialog.open(ManageProblemComponent, {
      data: {
        patient: this.patient,
        drp: this.data,
        from: 'manage',
        facility_cycle_date: this.patient.facility_cycle_date,
      },
      width: '75vw',
      maxWidth: '75vw',
      height: '85vh',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.refresh) {
        this.refresh.emit(result.refresh);
      }
    });
  }
  getMedication(value) {
    if (value) {
      if (this.medications.filter((item) => item.hicl_seqno === value)[0]) {
        return this.medications.filter((item) => item.hicl_seqno === value)[0].drug;
      }
    }
  }
}
